export const DEFAULT_AVATAR =
  'https://d1q14jmvwk39e0.cloudfront.net/public/assets/images/children.jpg';

export const DEFAULT_STORE =
  'https://d1q14jmvwk39e0.cloudfront.net/public/assets/images/brand_branch_noimg.jpg';
